export interface ChannelCategoryEntityProps {
  uuid: string;
  slug: string;
  name: string;
  channelsCount?: number;
}

export class ChannelCategoryEntity {
  private readonly props: ChannelCategoryEntityProps;
  private constructor(props: ChannelCategoryEntityProps) { this.props = { ...props }; }
  static create(props: ChannelCategoryEntityProps) { return new ChannelCategoryEntity(props); }
  get uuid() { return this.props.uuid; }
  get slug() { return this.props.slug; }
  get name() { return this.props.name; }
  get channelsCount() { return this.props.channelsCount; }
}
